import { PersonInfo } from './PersonInfo';
import { InsuranceCompany } from './InsuranceCompany';

export interface Patient extends PersonInfo {
  insuranceCompany?: InsuranceCompany;
  insuranceNumber: string;
  personalNumber: string;
  hasPersonalNumber: boolean;

  [key: string]: unknown;
}

export const defaultPatient: Patient = {
  titleBefore: '',
  titleAfter: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  note: '',
  hasPersonalNumber: true,
  insuranceNumber: '',
  personalNumber: ''
};
